(function () {
  'use strict';

  /* Per-shape size dimension labels */
  var SIZE_DIMS = {
    rectangle: {
      small:  '1.97" × 1.97" × 3.15"',
      medium: '2.3" × 2.3" × 3.5"',
      large:  '3.94" × 2.36" × 5.91"',
      xlarge: '4.72" × 3.15" × 7.09"'
    },
    heart: {
      small: '3.15" × 1.57" × 2.76"',
      large: '5.0" × 11.0" × 13.0"'
    },
    prestige: {
      small:  '2.36" × 2.36" × 2.36"',
      medium: '3.15" × 3.15" × 3.15"',
      large:  '3.94" × 3.94" × 3.94"'
    },
    iceberg: {
      one: '5.31" × 2.36" × 6.73"'
    }
  };


  /* Per-shape best seller badge */
  var SIZE_BADGE = {
    rectangle: { medium: 'Best Seller' },
    heart:     { small:  'Best Seller' },
    prestige:  { medium: 'Best Seller' },
    iceberg:   { one:    'Best Seller' }
  };

  /* track selected state */
  var state = {
    shape:      'rectangle',
    size:       'medium',
    engrave:    '3d',
    lightAddon:  null,
    lightPrice:  0,
    lightVariant: null,
    giftAddon:   null,
    giftPrice:   0,
    giftVariant: null,
    accessories: {}   /* key: addon-id, value: { price, variant } */
  };

  /* ── DOM ready ── */
  function init() {
    wireAccordionToggles();
    wireShapePicker();
    wireEngraveTabs();
    wireLightBase();
    wireAddonAddBtns();
    wireUploadCta();
    renderSizeList();
    renderGalleryStrip();
    recalcTotal();
  }

  /* ── Sync secondary file input to main, show photo panel on upload ── */
  function wireUploadCta() {
    var mainInput = document.getElementById('zkk-crystal-file');
    var ctaInput  = document.getElementById('zkk-crystal-file-main');
    var gallery   = document.getElementById('cxp-gallery-viewer');
    var panel     = document.getElementById('cxp-photo-panel');
    var uploadCta = document.getElementById('cxp-upload-cta');

    /* Mirror file selection from CTA input to main Zakeke input */
    if (ctaInput && mainInput) {
      ctaInput.addEventListener('change', function () {
        if (ctaInput.files && ctaInput.files[0]) {
          var dt = new DataTransfer();
          dt.items.add(ctaInput.files[0]);
          mainInput.files = dt.files;
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* When the main Zakeke input gets a file → switch to photo panel */
    if (mainInput) {
      mainInput.addEventListener('change', function () {
        if (mainInput.files && mainInput.files[0]) {
          if (gallery)   gallery.hidden   = true;
          if (uploadCta) uploadCta.hidden = true;
          if (panel)     panel.hidden     = false;
        }
      });
    }
  }

  /* ── "More info" toggles ── */
  function wireAccordionToggles() {
    wireToggle('cxp-acc-toggle',  'cxp-acc-chevron',  '.cxp-acc-tabs, .cxp-acc-panel');
    wireToggle('cxp-gift-toggle', 'cxp-gift-chevron', '#cxp-gift-grid');
  }

  function wireToggle(btnId, chevronId, targetSelector) {
    var btn     = document.getElementById(btnId);
    var chevron = document.getElementById(chevronId);
    if (!btn) return;
    var targets = document.querySelectorAll(targetSelector);
    var open = true;
    btn.addEventListener('click', function () {
      open = !open;
      targets.forEach(function (el) {
        if (open) { el.removeAttribute('hidden'); }
        else      { el.setAttribute('hidden', ''); }
      });
      if (chevron) chevron.style.transform = open ? '' : 'rotate(-90deg)';
    });
  }

  /* ── Shape picker ── */
  function wireShapePicker() {
    var grid = document.getElementById('cxp-shape-grid');
    if (!grid) return;

    var SHAPE_TO_ZKK = {
      rectangle: 'rectangle',
      heart:     'heart',
      prestige:  'diamond',
      iceberg:   'iceberg',
      notch:     'notch'
    };

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.cxp-shape-card');
      if (!card) return;

      grid.querySelectorAll('.cxp-shape-card').forEach(function (c) {
        c.classList.remove('cxp-shape-card--active');
      });
      card.classList.add('cxp-shape-card--active');

      state.shape = card.getAttribute('data-shape');

      /* Sync to Zakeke so the preview re-renders */
      var zkkShape = SHAPE_TO_ZKK[state.shape] || state.shape;
      if (window.crystalState) {
        window.crystalState.shape = zkkShape;
        if (typeof window.refreshCrystalPreview === 'function') window.refreshCrystalPreview();
      }

      /* Reset size to first available for new shape */
      renderSizeList();
      renderGalleryStrip();
      hideProductPreview();
      recalcTotal();
    });
  }

  /* ── 2D / 3D engraving toggle ── */
  function wireEngraveTabs() {
    var tabs = document.querySelectorAll('.cxp-engrave-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('cxp-engrave-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('cxp-engrave-tab--active');
        tab.setAttribute('aria-selected', 'true');
        state.engrave = tab.getAttribute('data-engrave');
        renderSizeList();
        recalcTotal();
        if (window.refreshCrystalPreview) window.refreshCrystalPreview();
      });
    });
  }

  /* ── Render size list for current shape + engraving ── */
  function renderSizeList() {
    var container = document.getElementById('zkk-crystal-size-pills');
    if (!container) return;

    var shapeMap = window.crystalVariants && window.crystalVariants[state.shape];
    if (!shapeMap) return;
    var sizes = Object.keys(shapeMap);

    /* If current size not available for this shape, default to first */
    if (sizes.indexOf(state.size) === -1) {
      state.size = sizes[0] || 'small';
    }

    var shapeBadges = SIZE_BADGE[state.shape] || {};
    var shapeDims   = SIZE_DIMS[state.shape]  || {};

    var html = '';
    sizes.forEach(function (sizeKey) {
      var sizeData  = shapeMap[sizeKey];
      var price     = state.engrave === '3d' ? (sizeData.price3d || 0) : (sizeData.price2d || 0);
      var isChecked = sizeKey === state.size;
      var badge     = shapeBadges[sizeKey] ? '<span class="cxp-size-badge cxp-size-badge--best">' + shapeBadges[sizeKey] + '</span>' : '';
      var dims      = shapeDims[sizeKey]   ? '<span class="cxp-size-row__dims">' + shapeDims[sizeKey] + '</span>' : '';
      var label      = sizeData.label || capFirst(sizeKey);

      html += '<label class="cxp-size-row' + (isChecked ? ' cxp-size-row--checked' : '') + '" data-size="' + sizeKey + '">'
        + '<input type="radio" name="cxp-size" value="' + sizeKey + '" class="cxp-size-radio"' + (isChecked ? ' checked' : '') + '>'
        + '<span class="cxp-size-row__info">'
        + '<strong>' + label + '</strong>'
        + badge + dims
        + '</span>'
        + '<span class="cxp-size-row__price"><span class="cxp-size-row__now">$' + price + '</span></span>'
        + '</label>';
    });

    container.innerHTML = html;

    /* Re-wire radio change events */
    container.querySelectorAll('.cxp-size-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          state.size = radio.value;
          container.querySelectorAll('.cxp-size-row').forEach(function (r) {
            r.classList.toggle('cxp-size-row--checked', r.getAttribute('data-size') === state.size);
          });
          if (window.crystalState) {
            window.crystalState.size = state.size;
            if (typeof window.updateCrystalSummary === 'function') window.updateCrystalSummary();
          }
          recalcTotal();
        }
      });
    });

    container.querySelectorAll('.cxp-size-row').forEach(function (row) {
      row.addEventListener('click', function () {
        var sz = row.getAttribute('data-size');
        if (sz) {
          var radio = row.querySelector('.cxp-size-radio');
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
        }
      });
    });
  }

  /* Returns the price for the current shape+size+engrave from window.crystalVariants */
  function getCurrentVariantPrice() {
    var map = window.crystalVariants;
    if (!map) return 0;
    var shapeMap = map[state.shape];
    if (!shapeMap) return 0;
    var sizeData = shapeMap[state.size] || shapeMap[Object.keys(shapeMap)[0]];
    if (!sizeData) return 0;
    return state.engrave === '3d' ? (sizeData.price3d || 0) : (sizeData.price2d || 0);
  }

  function capFirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* ── Light base grid ── */
  function wireLightBase() {
    var grid = document.getElementById('cxp-light-grid');
    if (!grid) return;

    /* Store initial light base variant from selected card */
    var sel = grid.querySelector('.cxp-addon-card--selected');
    if (sel) {
      state.lightVariant = sel.getAttribute('data-variant') || null;
    }

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.cxp-addon-card');
      if (!card) return;

      var isSelected = card.classList.contains('cxp-addon-card--selected');

      /* Deselect all */
      grid.querySelectorAll('.cxp-addon-card').forEach(function (c) {
        c.classList.remove('cxp-addon-card--selected');
        var chk = c.querySelector('.cxp-addon-card__check');
        if (chk) chk.remove();
      });

      if (isSelected) {
        /* Second click — unselect, clear state */
        state.lightAddon   = null;
        state.lightPrice   = 0;
        state.lightVariant = null;
      } else {
        /* First click — select */
        card.classList.add('cxp-addon-card--selected');
        var chk = document.createElement('span');
        chk.className = 'cxp-addon-card__check';
        chk.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
        card.prepend(chk);
        state.lightAddon   = card.getAttribute('data-addon');
        state.lightPrice   = parseInt(card.getAttribute('data-price'), 10) || 0;
        state.lightVariant = card.getAttribute('data-variant') || null;
      }

      recalcTotal();
    });
  }

  /* ── Addon "Add" buttons ──
     Gift wrap: only one at a time (inside #cxp-gift-grid)
     Accessories: toggle independently (inside #cxp-acc-grid)
  ── */
  function wireAddonAddBtns() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cxp-addon-add-btn');
      if (!btn) return;

      var id        = btn.getAttribute('data-addon');
      var price     = parseInt(btn.getAttribute('data-price'), 10) || 0;
      var card      = btn.closest('.cxp-addon-card');
      var variantId = card ? card.getAttribute('data-variant') : null;
      var inGift    = !!btn.closest('#cxp-gift-grid');

      if (inGift) {
        if (id === state.giftAddon) {
          state.giftAddon   = null;
          state.giftPrice   = 0;
          state.giftVariant = null;
          btn.textContent = 'Add';
          btn.classList.remove('is-added');
        } else {
          /* deselect any other gift btn */
          document.querySelectorAll('#cxp-gift-grid .cxp-addon-add-btn.is-added').forEach(function (b) {
            b.textContent = 'Add';
            b.classList.remove('is-added');
          });
          state.giftAddon   = id;
          state.giftPrice   = price;
          state.giftVariant = variantId;
          btn.textContent = '✓ Added';
          btn.classList.add('is-added');
        }
      } else {
        /* Accessory — toggle independently */
        if (state.accessories[id]) {
          delete state.accessories[id];
          btn.textContent = 'Add';
          btn.classList.remove('is-added');
        } else {
          state.accessories[id] = { price: price, variant: variantId };
          btn.textContent = '✓ Added';
          btn.classList.add('is-added');
        }
      }

      recalcTotal();
    });
  }

  /* ── Recalculate total ── */
  function recalcTotal() {
    var basePrice  = getCurrentVariantPrice();
    var lightPrice = state.lightPrice || 0;
    var accTotal   = 0;
    Object.keys(state.accessories).forEach(function (k) { accTotal += state.accessories[k].price; });
    var total      = basePrice + lightPrice + state.giftPrice + accTotal;

    var totalEl  = document.getElementById('cxp-total-price');
    var savedEl  = document.getElementById('cxp-saved-label');

    if (totalEl) totalEl.textContent = '$' + total;
    if (savedEl) savedEl.setAttribute('hidden', '');

    var orderBtn = document.getElementById('zkk-crystal-order-btn');
    var variantId = getSelectedCrystalVariant();
    if (orderBtn) {
      orderBtn.setAttribute('data-custom-price', String(total));
      if (variantId) orderBtn.setAttribute('data-variant-id', String(variantId));
      var shapeMap  = window.crystalVariants && window.crystalVariants[state.shape];
      var sizeData  = shapeMap && (shapeMap[state.size] || shapeMap[Object.keys(shapeMap)[0]]);
      var cartProps = {
        'Crystal Shape': sizeData && sizeData.shapeTitle ? sizeData.shapeTitle : capFirst(state.shape),
        'Size':          sizeData && sizeData.label ? sizeData.label : capFirst(state.size),
        'Effect':        state.engrave === '3d' ? '3D Engraving' : '2D Engraving',
        '_price':        '$' + total + '.00'
      };
      orderBtn.setAttribute('data-cart-props', JSON.stringify(cartProps));
    }

    /* Keep Zakeke form in sync — variant ID + product ID update per shape/size */
    var zkVariantInput  = document.getElementById('zkk-crystal-variant-id');
    var zkProductInput  = document.getElementById('zkk-crystal-product-id');
    if (zkVariantInput && variantId) zkVariantInput.value = String(variantId);
    if (zkProductInput && window.crystalProductIds) {
      var pid = window.crystalProductIds[state.shape];
      if (pid) zkProductInput.value = String(pid);
    }
  }

  /* ── Resolve current crystal variant ID from window.crystalVariants ── */
  function getSelectedCrystalVariant() {
    var map = window.crystalVariants;
    if (!map) return null;
    var shapeMap = map[state.shape];
    if (!shapeMap) return null;
    var sizeMap = shapeMap[state.size];
    if (!sizeMap) {
      /* Fall back to first available size for this shape */
      var firstSize = Object.keys(shapeMap)[0];
      sizeMap = shapeMap[firstSize];
    }
    if (!sizeMap) return null;
    return sizeMap[state.engrave] || sizeMap['3d'] || sizeMap['2d'] || null;
  }

  /* Expose addon items so zakeke-customizer.js can include them in its cart call */
  window.getCrystalAddonItems = function () {
    var items = [];
    if (state.lightVariant) {
      items.push({ id: parseInt(state.lightVariant, 10), quantity: 1 });
    }
    if (state.giftVariant) {
      items.push({ id: parseInt(state.giftVariant, 10), quantity: 1 });
    }
    Object.keys(state.accessories).forEach(function (k) {
      var acc = state.accessories[k];
      if (acc.variant) items.push({ id: parseInt(acc.variant, 10), quantity: 1 });
    });
    return items;
  };

  /* ── Product image gallery ── */
  function renderGalleryStrip() {
    var strip   = document.getElementById('cxp-gallery-strip');
    var mainImg = document.getElementById('cxp-gallery-main-img');
    if (!strip || !mainImg) return;

    var images = window.crystalProductImages && window.crystalProductImages[state.shape];
    if (!images || images.length === 0) return;

    /* Set main image to first */
    mainImg.src = images[0];

    var html = '';
    images.forEach(function (src, i) {
      html += '<button type="button" class="cxp-gallery-thumb' + (i === 0 ? ' cxp-gallery-thumb--active' : '') + '" data-src="' + src + '" aria-label="Product image ' + (i + 1) + '">'
        + '<img src="' + src + '" alt="" loading="' + (i === 0 ? 'eager' : 'lazy') + '">'
        + '</button>';
    });
    strip.innerHTML = html;

    strip.querySelectorAll('.cxp-gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        strip.querySelectorAll('.cxp-gallery-thumb').forEach(function (t) {
          t.classList.remove('cxp-gallery-thumb--active');
        });
        thumb.classList.add('cxp-gallery-thumb--active');
        swapMainImage(thumb.getAttribute('data-src'));
      });
    });
  }

  function swapMainImage(src) {
    var mainImg = document.getElementById('cxp-gallery-main-img');
    if (!mainImg) return;
    mainImg.classList.add('is-changing');
    setTimeout(function () {
      mainImg.src = src;
      mainImg.classList.remove('is-changing');
    }, 200);
  }

  function hideProductPreview() {
    /* no-op — shape change just re-renders gallery with new images */
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
